import { useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Reusable hook for uploading a canvas blob to the BLVX media server.
 * Used by both ComposerModal (inline canvas export) and LabPage (standalone).
 */
export function useCanvasUpload() {
  const [uploading, setUploading] = useState(false);

  const uploadCanvas = useCallback(async (blob) => {
    setUploading(true);
    try {
      const file = new File([blob], `canvas_${Date.now()}.png`, { type: 'image/png' });
      const formData = new FormData();
      formData.append('file', file);
      const response = await axios.post(`${API}/upload`, formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return { url: response.data.url, storage: response.data.storage };
    } finally {
      setUploading(false);
    }
  }, []);

  return { uploadCanvas, uploading };
}
